import { render, staticRenderFns } from "./valuerule.vue?vue&type=template&id=99108d08&"
import script from "./valuerule.vue?vue&type=script&lang=js&"
export * from "./valuerule.vue?vue&type=script&lang=js&"
import style0 from "./valuerule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports